import { ComponentType, SVGProps } from 'react'
import { cn } from '@/lib/utils'

interface ProfileKpiCardProps {
	title: string
	icon: ComponentType<SVGProps<SVGSVGElement>>
	value: string
	decimals?: string
	gradientClassName: string
	bannerTextClassName: string
}

export function KpiCard({ title, icon: Icon, value, decimals = '', gradientClassName, bannerTextClassName }: ProfileKpiCardProps) {
	return (
		<div className='relative flex min-h-[132px] flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<div className={cn('flex h-12 items-center justify-center gap-2 rounded-b-[24px] border-b border-border', gradientClassName)}>
				<Icon className={cn('h-5 w-5', bannerTextClassName)} />
				<span className={cn('text-sm font-semibold tracking-[-0.21px]', bannerTextClassName)}>{title}</span>
			</div>
			<div className='flex flex-1 items-center justify-center px-4 py-6 text-center tracking-[-0.24px]'>
				<span className='text-2xl font-semibold text-foreground'>{value}</span>
				<span className='text-base font-semibold text-muted-foreground'>{decimals}</span>
			</div>
		</div>
	)
}
